export const achievementType = {
  TOKEN: 'TOKEN', //令牌
  CUP: 'CUP', //奖杯
  MEDAL: 'MEDAL', //勋章
}

export const AWARD_TYPE_LABEL = {
  MONTH: '月度令牌', //令牌
  TERM: '赛季奖杯', //奖杯
  BOOK: '段位勋章', //勋章
}

export const AWARD_TYPE = {
  MONTH: 'MONTH', //令牌
  TERM: 'TERM', //奖杯
  BOOK: 'BOOK', //勋章
}
